import { render, staticRenderFns } from "./OrderPending.vue?vue&type=template&id=5f4cd3e2&scoped=true&"
import script from "./OrderPending.vue?vue&type=script&lang=js&"
export * from "./OrderPending.vue?vue&type=script&lang=js&"
import style0 from "./OrderPending.vue?vue&type=style&index=0&id=5f4cd3e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-2f6a8101d6/2/home/apps/.yarn/berry/cache/vue-loader-npm-15.10.1-3a0b6c19d2-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4cd3e2",
  null
  
)

export default component.exports